import { useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "../../components/ui/dialog";
import { Textarea } from "../../components/ui/textarea";
import { errMsg } from "../../lib/api";

export function JsonDialog({ title, initial, onSave, trigger, testid }) {
  const [open, setOpen] = useState(false);
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const save = async () => {
    let v;
    try { v = JSON.parse(text); } catch { return toast.error("That isn't valid JSON. Check commas and quotes."); }
    setBusy(true);
    try { await onSave(v); setOpen(false); toast.success("Saved"); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={(o) => { setOpen(o); if (o) setText(JSON.stringify(initial, null, 2)); }}>
      <DialogTrigger asChild>{trigger}</DialogTrigger>
      <DialogContent className="max-w-2xl"><DialogHeader><DialogTitle>{title}</DialogTitle></DialogHeader>
        <Textarea rows={20} value={text} onChange={(e) => setText(e.target.value)} className="font-mono text-xs" data-testid={`${testid}-json`} />
        <button onClick={save} disabled={busy} className="btn-emerald self-end" data-testid={`${testid}-save`}>Save</button>
      </DialogContent>
    </Dialog>
  );
}

export function Table({ cols, rows, testid }) {
  return (
    <div className="overflow-auto border rounded-md bg-white" data-testid={testid}>
      <table className="w-full text-sm">
        <thead className="bg-[#f4efe2] text-left"><tr>{cols.map(([k, l]) => <th key={k} className="px-3 py-2 font-semibold text-xs uppercase tracking-wider whitespace-nowrap">{l}</th>)}</tr></thead>
        <tbody>{rows.length === 0 ? <tr><td className="px-3 py-4 text-slate-500" colSpan={cols.length}>Nothing here yet.</td></tr> : rows.map((r, i) => (
          <tr key={r.id || r.key || r.code || r.user_id || i} className="border-t align-top">{cols.map(([k, , fn]) => <td key={k} className="px-3 py-2">{fn ? fn(r) : String(r[k] ?? "—")}</td>)}</tr>))}</tbody>
      </table>
    </div>
  );
}

export const Btn = (p) => <button {...p} className={`text-xs px-2.5 py-1 border rounded hover:bg-[#f4efe2] ${p.className || ""}`} />;
